import { MagnifyingGlassIcon } from '@heroicons/react/16/solid';

interface SearchBarProps {
  searchFunction: React.ChangeEventHandler<HTMLInputElement>;
}

const SearchBar = ({ searchFunction }: SearchBarProps) => {
  return (
    <div className="mt-2">
      <label htmlFor="email" className="sr-only">
        Search
      </label>
      <div className="mt-2 grid grid-cols-1">
        <input
          id="search"
          name="search"
          type="text"
          placeholder="Search"
          onChange={searchFunction}
          className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-3 pl-10 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:pl-9 sm:text-sm/6"
        />
        <MagnifyingGlassIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
        />
      </div>
    </div>
  );
};

export default SearchBar;
